import { render, staticRenderFns } from "./pdfs.vue?vue&type=template&id=6b59bb29&scoped=true&"
import script from "./pdfs.vue?vue&type=script&lang=js&"
export * from "./pdfs.vue?vue&type=script&lang=js&"
import style0 from "./pdfs.vue?vue&type=style&index=0&id=6b59bb29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b59bb29",
  null
  
)

export default component.exports